export default "__VITE_ASSET__BRGPkw85__"